import APIClient from '@/shared/http/clients/api'

const resourceName = 'pessoa'
const APICore = process.env.APIBaseURLCore

const Create = (pessoaId, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/${pessoaId}/funcionario/`, data, config)

const PessoaEmployeeRepository = {
  Create
}

export default PessoaEmployeeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/personEmployee.js